import isEmpty from "lodash/isEmpty";
import get from "lodash/get";
import axios from "axios";
import config from "@/config/env.config.json";
import logger from "@/utils/logger";

const envConfig = config[process.env.NODE_ENV];
const siteAccessId = envConfig.pactsafe.siteAccessId;
const clickwrapGroupId = envConfig.pactsafe.signInGroupClickwrapId;

export function loadPactsafe() {
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.onload = () => resolve();
    script.setAttribute("src", "https://vault.pactsafe.io/ps.min.js");
    document.head.appendChild(script);
  });
}

export async function createSignInClickwrap(htmlElementId, signerValue) {
  if (isEmpty(window._ps)) {
    await loadPactsafe();
  }

  // Creates a Site object with the a Clickwrap Site Access ID.
  window._ps("create", siteAccessId, { disable_sending: true });
  window._ps("set", "signer_id", signerValue);

  const groupOptions = {
    container_selector: htmlElementId,
    display_all: false,
  };
  window._ps("load", clickwrapGroupId, groupOptions);
}

export function hasAcceptedSigninClickwrap() {
  // Check to ensure we're able to get the Group successfully.
  if (window._ps.getByKey(clickwrapGroupId)) {
    // block() returns a boolean flag (true) indicating if any contracts in the Group still need to be accepted.
    return !window._ps.getByKey(clickwrapGroupId).block();
  }

  logger.info(
    "Issue finding the group, blocking form submission just in case."
  );
  return false;
}

export async function hasAcceptedSigninClickwrapApi(signer) {
  try {
    const url = `https://pactsafe.io/latest?sid=${siteAccessId}&gkey=${clickwrapGroupId}&sig=${signer}`;
    const response = await axios.get(url);

    logger.info(response);
    const contracts = get(response, "data", null);

    if (!contracts) {
      return false;
    }

    return Object.values(contracts).every((val) => val === true);
  } catch (error) {
    logger.error(error);
    return false;
  }
}

export function isSignInClickwrapChecked() {
  const clickwrapGroup = window._ps.getByKey(clickwrapGroupId);

  if (!clickwrapGroup) {
    logger.info(
      "Issue finding the group, blocking form submission just in case."
    );
    return false;
  }

  return clickwrapGroup.allChecked();
}

export async function markSignInClickwrapAsAccepted() {
  return new Promise((resolve, reject) => {
    // Manually send acceptance with the Clickwrap Group.
    window._ps(`${clickwrapGroupId}:send`, "agreed", {
      disable_sending: false, // We have to revert to allow sending with the snippet here.
      event_callback: function (err, eventType, group, request) {
        if (err) {
          // Something went wrong with sending the event.
          logger.info("There was an issue accepting the clickwrap group", err);
          return reject(err);
        }

        return resolve({ eventType, group, request });
      },
    });
  });
}
